import t from "../../../depend/rc-util/lib/Children/toArray.mjs";
function r(n) {
  if (typeof n == "function")
    return n;
  const o = t(n);
  return o.length <= 1 ? o[0] : o;
}
export {
  r as default
};
//# sourceMappingURL=useChildren.mjs.map
